export default "__VITE_ASSET__59674461__"